var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTags.length)?_c('span',{staticClass:"user-tags"},_vm._l((_vm.showTags),function(tag){return _c('span',{key:tag.key,class:['tag-badge', tag.className],attrs:{"title":tag.label}},[_vm._v(_vm._s(tag.text))])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7534b5a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserTags.vue
// module id = aWzF
// module chunks = 102